<div class="upload-modal">
  <div mat-dialog-titled>
    @if (supportsVideos) {
      <div>
        <h2 mat-dialog-title>{{ "campaign.widget.sidebar.media.add-media" | translate }}</h2>
      </div>
    } @else {
      <div>
        <h2 mat-dialog-title>{{ "campaign.widget.sidebar.media.add-image" | translate }}</h2>
      </div>
    }
  </div>
  @if (isUploading) {
    <mat-dialog-content class="mat-typography content-loading">
      <mat-progress-spinner mode="indeterminate" [diameter]="48"></mat-progress-spinner>
    </mat-dialog-content>
  } @else {
    <mat-dialog-content class="mat-typography">
      <div class="img-container checkerboard">
        @if (category === MediaCategory.Videos) {
          <div class="video-placeholder">
            <mat-icon class="video-icon">play_circle_filled</mat-icon>
            <span class="video-label">{{ "campaign.widget.sidebar.media.upload-videos.video-upload-preview-text" | translate }}</span>
          </div>
        } @else {
          <img [src]="mediaUrl" alt="Thumbnail of uploaded Image" />
        }
      </div>
      @if (category === MediaCategory.Videos) {
        <p class="info-text">
          <mat-icon class="center">info</mat-icon>
          {{ "campaign.widget.sidebar.media.upload-videos.video-info-text" | translate }}
        </p>
      }
      <div class="path-options">
        <div class="label">{{ "campaign.widget.sidebar.media.category" | translate }}</div>
        <mat-radio-group [(ngModel)]="category" (change)="onCategoryChange($event)">
          @if (!isUploadingVideo) {
            <mat-radio-button [value]="MediaCategory.Photos" checked>{{ "campaign.widget.sidebar.media.photos" | translate }}</mat-radio-button>
            <mat-radio-button [value]="MediaCategory.Graphics">{{ "campaign.widget.sidebar.media.graphics" | translate }}</mat-radio-button>
          } @else if (supportsVideos) {
            <mat-radio-button [value]="MediaCategory.Videos">{{ "campaign.widget.sidebar.media.videos" | translate }}</mat-radio-button>
          }
        </mat-radio-group>
        <div class="label">{{ "campaign.widget.sidebar.media.collection" | translate }}</div>
        <mat-form-field class="input-full-width" appearance="outline">
          <mat-label>{{ "campaign.widget.sidebar.media.collection" | translate }} ({{ "generic.optional" | translate }})</mat-label>
          <input type="text" matInput [(ngModel)]="collection" [matAutocomplete]="auto" [formControl]="collectionControl" />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option [value]="null">{{ "generic.none" | translate }}</mat-option>
            @for (collection of filteredOptions | async; track trackByCollection($index, collection)) {
              <mat-option [value]="collection">{{ collection }}</mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-stroked-button class="secondary-button" mat-dialog-close>{{ "generic.cancel" | translate }}</button>
      <button mat-stroked-button class="primary-button" (click)="addMedia()">{{ "generic.add" | translate }}</button>
    </mat-dialog-actions>
  }
</div>
